import React, {useState} from "react";
import {useDispatch} from "react-redux";
import Select from 'react-select';
import Toaster from "../../../../components/Toaster";
import LoadingPanel from "../../../../components/LoadingPanel/index";
import * as userActions from "../../../../redux/User/actions";

import './CreateInternalUser.scss';

const CreateInternalUser = ({availableAccounts, onClose, onCreateUser}) => {
	const [loading, setLoading] = useState(false);
	const [account, setAccount] = useState(availableAccounts.find(a => a.value === 'AnyCompany'));
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const dispatch = useDispatch();

	const onAccountChange = async accountName => {
		setAccount(accountName);
	};

	const userCreated = (result) => {
		setLoading(false);
		if(result.status === "error") {
			Toaster.showError("User creation failed. Please verify if an account with this email already exists.");
		}
		else {
			onClose();
		}
	};

	const validateEmail = (email) => {
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(String(email).toLowerCase());
	}

	const createUser = () => {
		if(!validateEmail(email)) {
			Toaster.showWarn("Please email a valid email");
		}
		else {
			setLoading(true);
			dispatch(userActions.createInternalUser(email, name, account.value, userCreated));
		}
	};

	// Use effect to call onCreateUser when component mounts with the createUser function
	React.useEffect(() => {
		if (onCreateUser) {
			onCreateUser(createUser);
		}
	}, [email, name, account]);

	return (
		<div>

			{ loading && <LoadingPanel /> }

			<div className="create-user-fields">
				<b style={{fontWeight: 'bold'}}>Account:</b>
				<div style={{textAlign: 'left'}}>
					<Select
						styles={{
							menuList: (provided, state) => ({
								...provided,
								maxHeight: '300px'
							}),
						}}
						value={account}
						onChange={onAccountChange}
						options={availableAccounts}
					/>
				</div>
				<b style={{fontWeight: 'bold'}}>Email:</b>
				<input className="edit-field-styles" style={{fontSize: '14px', width: '100%'}} type="text" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter email..." />
				<b style={{fontWeight: 'bold'}}>Name:</b>
				<input className="edit-field-styles" style={{fontSize: '14px', width: '100%'}} type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Enter name..." />

			</div>
		</div>
	)
};

export default CreateInternalUser;
